import { render } from "./HeroiconsOutlinePaperAirplane.vue?vue&type=template&id=6b696cc8"
const script = {}

import exportComponent from "/Users/mior/Projects/laravel/nova/silver-surfer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlinePaperAirplane.vue"]])

export default __exports__